<template lang="html">
  <div class="toast">
    <div class="toast-mask">
      <div class="toast-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    setTimeout(() => {
      this.$emit('input', false)
    }, 3000)
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/mixin';

.toast {
  position: absolute;
  z-index: 999999;
  top: 0;
  bottom: 0;
  width: 100%;
  max-width: rem(750px);
  .toast-mask {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .toast-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.7);
      padding: 0 rem(20px);
      font-size: rem(30px);
      line-height: rem(90px);
      color: #fff;
      border-radius: rem(10px);
    }
  }
}
</style>
